export const headers = [
  { name: 'Asset Name', id: 'name' },
  { name: 'Categories', id: 'asset_category' },
  { name: 'Location', id: 'location_description' },
  { name: 'Check Due', id: 'check_due' },
  { name: 'Assigned To', id: 'assigned_to' },
  { name: 'Status', id: 'status' }
];
